import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch } from '@store/hooks';
import { addRevaluation } from '@store/Finance/FixedAssets/Revaluation/RevaluationSlice';
import { useNavigate } from 'react-router-dom';
import DepreciationLines from './RevaluationLines';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import Loading from '@components/Shared/Loader/Loading';
// import { AddReceiveTransactionsSchema } from '@pages/ValidationForm/validationSchema';
import useGetFACategoriesList from '@hooks/FixedAssets/useGetFACategoriesList';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import { AddRevaluationSchema } from '@pages/ValidationForm/validationSchema';

const Add = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const { OptionsFACategories, loading, error } = useGetFACategoriesList();

  const { OrganizationOptions } = useGetOrganizations();

  const {
    OperatingUnitOptions,
    loading: loading1,
    error: error1
  } = useGetOperatingUnitWithPermission();

  //#region Formik
  const formik = useFormik({
    initialValues: {
      organizationId: '',
      categoryId: '',
      transactionDate: new Date().toISOString().split('T')[0],
      description: '',

      transactionsLinesList: [
        {
          assetId: null,
          amount: 0,
          currentCost: 0,
          removalCost: 0,
          newCost: 0,
          retirementType: '',
          description: ''
        }
      ] as any[]
    },
    enableReinitialize: true,
    validationSchema: AddRevaluationSchema(t),
    onSubmit: values => {
      dispatch(
        addRevaluation({
          organizationId: values.organizationId,
          categoryId: values.categoryId,
          transactionDate: values.transactionDate,
          description: values.description,

          transactionsLinesList: formik.values.transactionsLinesList?.map((item: any) => ({
            assetId: item.assetId,
            amount: item.amount,
            currentCost: item.currentCost,
            removalCost: item.removalCost,
            newCost: item.newCost,
            retirementType: item.retirementType,
            description: item.description
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            // Navigate('/INV/Transactions/InvReceive', { replace: true });
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched } = formik;
  //#endregion
  console.log(errors);
  

  //____________________________
  const BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: 'إعادة تقييم الأصــول',
      link: ''
    },
    {
      name: 'تقييم جديـد',
      link: null
    }
  ];

  // console.log(values);

  return (
    <div>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName='تقييم جديــد' />

      <Card>
        <CardBody>
          <Loading loading={loading1} error={error1}>
            <Form onSubmit={formik.handleSubmit}>
              <div className='row '>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('التاريـخ')}</label>
                    <Form.Control
                      className='form-control  text-center'
                      type='date'
                      name='transactionDate'
                      onChange={formikhandleChange}
                      value={values.transactionDate || ''}
                      // isInvalid={!!(touched.transactionDate && errors.transactionDate)}
                    />
                    <div className='text-danger small'>
                      {formik.touched.transactionDate && formik.errors.transactionDate}
                    </div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('وحدة التشغيل')}</label>
                    <Select
                      classNamePrefix='react-select'
                      isLoading={loading1}
                      isSearchable={true}
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find(
                        (f: any) => f.value === formik.values.organizationId
                      )}
                      onChange={option => {
                        formik.setFieldValue('organizationId', option?.value || null);
                      }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>
                      {formik.touched.organizationId && formik.errors.organizationId}
                    </div>
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الإدارة')}</label>
                    <Select
                      classNamePrefix='react-select'
                      isLoading={loading1}
                      isSearchable={true}
                      isClearable
                      options={OrganizationOptions.filter(
                        (f: any) => f.operatingUnitId === values.organizationId
                      )}
                      // value={OrganizationOptions?.find(
                      //   (f: any) => f.value === formik.values.organizationId
                      // )}
                      // onChange={option => {
                      //   formik.setFieldValue('_', option?.value || null);
                      // }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>
                      {formik.touched.organizationId && formik.errors.organizationId}
                    </div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الفئــة')}</label>
                    <Select
                      classNamePrefix='react-select'
                      isLoading={loading}
                      isSearchable={true}
                      isClearable
                      options={OptionsFACategories}
                      value={OptionsFACategories?.find((f: any) => f.value === values.categoryId)}
                      onChange={option => {
                        formik.setFieldValue('categoryId', option?.value || null);
                      }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>
                      {touched.categoryId && errors.categoryId}
                    </div>
                  </div>
                </div>

                <div className='col-lg-12'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('ملاحظـات')}</label>
                    <Form.Control
                      autoComplete='off'
                      className='form-control'
                      as='textarea'
                      rows={1}
                      name='description'
                      onChange={formik.handleChange}
                      value={values.description}
                    />
                  </div>
                </div>
              </div>
              <div className='row m-0 p-0'>
                <div className='bg-inverse bg-opacity-5 p-2'>
                  <DepreciationLines formik={formik} />
                </div>
              </div>

              <div className='text-center mt-3'>
                <button
                  disabled={formik.isSubmitting}
                  type='submit'
                  className='btn btn-lg me-1 btn-theme mb-1'
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                  )}
                  {t('Add')}
                </button>
                <button
                  type='button'
                  className='btn btn-lg  me-1 btn-default mb-1'
                  onClick={() => Navigate(-1)}
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </Form>
          </Loading>
        </CardBody>
      </Card>
    </div>
  );
};

export default Add;
